/**
 * 任务列表
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>任务列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="user-search" label-width="100px">
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="任务ID :">
            <el-input
              size="small"
              v-model="formInline.taskId"
              placeholder="请输入任务ID"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="任务名称 :">
            <el-input
              size="small"
              v-model="formInline.taskName"
              placeholder="请输入任务名称"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="任务状态 :">
            <el-select
              size="small"
              v-model="formInline.status"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in status_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="发布时间: ">
            <el-date-picker
              size="small"
              v-model="formInline.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label-width="30px">
            <el-button size="small" type="primary" @click="search"
              >搜索</el-button
            >
            <el-button size="small" @click="reset()">清空</el-button>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4"> </el-col>
      </el-row>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button size="small" type="primary" @click="add_task"
        >发布任务</el-button
      >
      <el-button size="small" @click="exportData">导出数据</el-button>
      <el-button size="small" @click="onTaskMigration">任务导入</el-button>
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column
        fixed
        prop="taskName"
        label="任务名称"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="taskId"
        label="任务ID"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="taskTypeStr"
        label="任务类型"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.taskTypeStr }}</div>
        </template>
      </el-table-column>
      <el-table-column label="用工周期" show-overflow-tooltip min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.startTime }} - {{ scope.row.endTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="计费范围" show-overflow-tooltip min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.minCharge }} - {{ scope.row.maxCharge }}元/月</div>
        </template>
      </el-table-column>
      <el-table-column label="年龄要求" show-overflow-tooltip min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.minAge }} - {{ scope.row.maxAge }}岁</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="location"
        label="服务地点"
        show-overflow-tooltip
        min-width="180"
      >
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="发布时间"
        show-overflow-tooltip
        min-width="160"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="任务状态"
        show-overflow-tooltip
        min-width="80"
      >
        <template slot-scope="scope">
          <el-switch
            :active-value="1"
            :inactive-value="0"
            v-model="scope.row.status"
            @change="changeStatus(scope.row.status, scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="registrationDtl"
        label="报名详情"
        show-overflow-tooltip
        min-width="80"
      >
        <template slot-scope="scope">
          <el-link type="primary" @click="viewRegistrationDtl(scope.row.taskId)"
            >查看</el-link
          >
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        min-width="250"
      >
        <template slot-scope="scope">
          <!-- <el-button type="primary" size="small" plain>报名详情</el-button> -->
          <el-button
            type="primary"
            size="small"
            plain
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="primary"
            size="small"
            plain
            @click="showShareDialog(scope.row)"
          >
            分享
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="deleteUser(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="form_dialog.title"
      :visible.sync="form_dialog.visible"
      width="80%"
      @click="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="95px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
        label-position="left"
      >
        <div class="info-block">
          <p class="info-title"><span class="title">基本信息</span></p>
          <!--默认-->
          <div class="info-body">
            <el-row :gutter="30">
              <el-col :md="11" :xl="6">
                <el-form-item label="任务类型:" prop="taskType">
                  <el-select
                    size="small"
                    v-model="editForm.taskType"
                    placeholder="请选择"
                    filterable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(val, index) in tasktype_list"
                      :label="val.name"
                      :value="val.id"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :md="11" :xl="{ span: 6, offset: 1 }">
                <el-form-item label="任务名称:" prop="taskName">
                  <el-input
                    size="small"
                    style="width: 100%"
                    v-model="editForm.taskName"
                    auto-complete="off"
                    placeholder="请输入任务名称"
                  ></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :md="11" :xl="6">
                <el-form-item label="结算周期:" prop="settlementCycle">
                  <el-select
                    size="small"
                    v-model="editForm.settlementCycle"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(val, index) in settlementCycle_list"
                      :label="val.label"
                      :value="val.value"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :md="11" :xl="{ span: 6, offset: 1 }">
                <el-form-item label="用工周期:" prop="date">
                  <el-date-picker
                    size="small"
                    v-model="editForm.date"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="right"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :md="5" :xl="3">
                <el-form-item label="任务计费:" prop="minCharge">
                  <el-input
                    size="small"
                    v-model="editForm.minCharge"
                    auto-complete="off"
                    placeholder="最低计费"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="3" :xl="2">
                <el-form-item label="~" prop="maxCharge" label-width="15px">
                  <el-input
                    size="small"
                    v-model="editForm.maxCharge"
                    auto-complete="off"
                    placeholder="最高计费"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="3" :xl="2">
                <el-form-item label="元 /" prop="unit" label-width="34px">
                  <el-select
                    size="small"
                    v-model="editForm.unit"
                    placeholder="单位"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(val, index) in unit_list"
                      :label="val.label"
                      :value="val.value"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="info-block">
          <p class="info-title"><span class="title">任务要求</span></p>
          <!--默认-->
          <div class="info-body">
            <el-row :gutter="30">
              <el-col :md="11" :xl="6">
                <el-form-item label="性别要求:" prop="gender">
                  <el-select
                    size="small"
                    v-model="editForm.gender"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(val, index) in gender_list"
                      :label="val.label"
                      :value="val.value"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="11" :xl="{ span: 6, offset: 1 }">
                <el-form-item label="学历要求:" prop="educationLevel">
                  <el-select
                    size="small"
                    v-model="editForm.educationLevel"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(val, index) in educationLevel_list"
                      :label="val.label"
                      :value="val.value"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :md="6" :xl="3">
                <el-form-item label="年龄要求:" prop="minAge">
                  <el-input
                    size="small"
                    v-model="editForm.minAge"
                    auto-complete="off"
                    placeholder="最小年龄"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="5" :xl="3">
                <el-form-item label=" ~" prop="maxAge" label-width="15px">
                  <el-input
                    size="small"
                    v-model="editForm.maxAge"
                    auto-complete="off"
                    placeholder="最大年龄"
                    style="width: 90%"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="info-block">
          <p class="info-title"><span class="title">任务详情</span></p>
          <!--默认-->
          <div class="info-body">
            <el-row :gutter="30">
              <el-col :md="23" :xl="13">
                <el-form-item label="服务地点：" prop="locationVoList">
                  <el-select
                    size="small"
                    v-model="editForm.locationVoList[0].province"
                    placeholder="请选择"
                    @change="provinceChanged"
                    style="width: 31%"
                  >
                    <el-option
                      v-for="(val, index) in province_list"
                      :label="val.name"
                      :value="val"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <el-select
                    size="small"
                    v-model="editForm.locationVoList[0].city"
                    placeholder="请选择"
                    @change="cityChanged"
                    style="width: 31%"
                  >
                    <el-option
                      v-for="(val, index) in city_list"
                      :label="val.name"
                      :value="val"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <el-select
                    size="small"
                    v-model="editForm.locationVoList[0].district"
                    placeholder="请选择"
                    style="width: 31%"
                  >
                    <el-option
                      v-for="(val, index) in district_list"
                      :label="val.name"
                      :value="val.name"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :md="22" :xl="13">
                <el-form-item label="服务内容：" prop="content">
                  <el-input
                    type="textarea"
                    placeholder="请填写服务内容（10-1000字），例如：外卖配送员，公司配电动车，时间自由，全北京区域就近分配。"
                    v-model="editForm.content"
                    maxlength="1000"
                    show-word-limit
                    style="width: 100%"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :md="22" :xl="13">
                <el-form-item label="计费模式：" prop="billMode">
                  <el-input
                    type="textarea"
                    placeholder="请填写服务费计费模式（10-200字），例如：每单赚的8-20元，多劳多得（上不封顶），一天260-380元，服务费当日结。"
                    v-model="editForm.billMode"
                    maxlength="200"
                    show-word-limit
                    style="width: 100%"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :md="22" :xl="13">
                <el-form-item label="服务时间：" prop="serviceTime">
                  <el-input
                    type="textarea"
                    placeholder="请填写提供服务的时间（10-100字），例如：周一到周日，上午10:00-14:00 下午17:00-21:00，时间自由选择"
                    v-model="editForm.serviceTime"
                    maxlength="100"
                    show-word-limit
                    style="width: 100%"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :md="22" :xl="13">
                <el-form-item label="其他福利：" prop="otherBenefits">
                  <el-input
                    type="textarea"
                    placeholder="请填写可提供的其他福利（此处选填），例如：公司提供电动车，无需押金。可以享受高温补贴、高峰补贴、雨天补贴、恶略天气补贴，每单3-5元。"
                    v-model="editForm.otherBenefits"
                    maxlength="100"
                    show-word-limit
                    style="width: 100%"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="shareDialogVisible"
      title="分享二维码"
      width="500px"
    >
      <div class="qrcode-container" v-if="qrcodeLoading">
        <i class="el-icon-loading"></i> 正在加载二维码...
      </div>

      <div class="qrcode-container" v-else-if="qrcodeUrl">
        <!-- 二维码图片 -->
        <img :src="qrcodeUrl" alt="二维码" />

        <!-- 任务名称 -->
        <div class="task-name">
          {{ this.qrTaskName }}
        </div>
      </div>

      <div class="qrcode-container" v-else>获取二维码失败，请稍后重试。</div>

      <template slot="footer">
        <span class="dialog-footer">
          <el-button v-if="qrcodeUrl" type="primary" @click="downloadQRCode">
            <i class="el-icon-download"></i> 保存二维码
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      :visible.sync="taskMigrationDialogVisible"
      title="任务导入"
      width="70%"
    >
      <el-table
        ref="multipleTable"
        size="small"
        :data="taskMigrationList"
        highlight-current-row
        v-loading="taskMigrationLoading"
        element-loading-text="拼命加载中"
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
        >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="taskName" label="任务名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="taskId" label="任务ID" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="taskTypeStr"
          label="任务类型"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="distributeCompanyName"
          label="服务商"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="用工周期" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="ellipsis-text">
              {{ scope.row.startTime }} - {{ scope.row.endTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="计费范围" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="ellipsis-text">
              {{ scope.row.minCharge }} - {{ scope.row.maxCharge }}元/月
            </div>
          </template>
        </el-table-column>
        <el-table-column label="年龄要求" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="ellipsis-text">
              {{ scope.row.minAge }} - {{ scope.row.maxAge }}岁
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="location" label="服务地点" show-overflow-tooltip>
        </el-table-column>

        <el-table-column label="任务详情" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-popover placement="top" trigger="hover">
              <div style="white-space: pre-line">
                【服务内容】{{ scope.row.content || "" }} <br />
                【计费模式】{{ scope.row.billMode || "" }} <br />
                【服务时间】{{ scope.row.serviceTime || "" }} <br />
                【其他福利】{{ scope.row.otherBenefits || "" }}
              </div>
              <template #reference>
                <span style="cursor: pointer; color: #409eff">查看详情</span>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="createdAt"
          label="发布时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="status" label="任务状态" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-switch
              :active-value="1"
              :inactive-value="0"
              v-model="scope.row.status"
              :disabled="true"
            >
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px">
        <el-button size="small" @click="toggleSelection()">取消选择</el-button>
        <el-button size="small" type="primary" @click="handleTaskMigration()"
          >导入</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  deptList,
  editDeptList,
  getQrcodeUrl,
  editDeptListStatus,
  createDeptList,
  exportTask,
  gettasksTypes,
  getDisLimit,
  getAllAccountTasks,
  tasksMigration,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import { china } from "../../common/area.js";
export default {
  data() {
    return {
      status_list: [
        {
          label: "上线",
          value: 1,
        },
        {
          label: "下线",
          value: 0,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      taskMigrationList: [],
      multipleSelectionTasks: [],
      taskMigrationLoading: false,
      taskMigrationDialogVisible: false,
      shareDialogVisible: false,
      qrcodeUrl: "",
      qrcodeLoading: false,
      qrTaskName: "",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      form_dialog: {
        visible: false, //控制编辑页面显示与隐藏
        title: "新建任务",
      },
      editForm: {
        taskType: "",
        date: [],
        // taskId: '',
        taskName: "",
        settlementCycle: "",
        minCharge: "",
        maxCharge: "",
        unit: "",
        gender: "",
        educationLevel: "",
        minAge: "",
        maxAge: "",
        content: "",
        billMode: "",
        serviceTime: "",
        otherBenefits: "",
        locationVoList: [
          {
            province: "",
            city: "",
            district: "",
          },
        ],
      },
      tasktype_list: [],
      settlementCycle_list: [
        {
          label: "日结",
          value: 1,
        },
        {
          label: "周结",
          value: 2,
        },
        {
          label: "月结",
          value: 3,
        },
      ],
      unit_list: [
        {
          label: "日",
          value: 1,
        },
        {
          label: "月",
          value: 2,
        },
        {
          label: "小时",
          value: 3,
        },
        {
          label: "次",
          value: 4,
        },
        {
          label: "个",
          value: 5,
        },
        {
          label: "件",
          value: 6,
        },
      ],
      gender_list: [
        {
          label: "男女不限",
          value: 0,
        },
        {
          label: "男",
          value: 1,
        },
        {
          label: "女",
          value: 2,
        },
      ],
      educationLevel_list: [
        {
          label: "学历不限",
          value: 1,
        },
        {
          label: "初中及以上",
          value: 2,
        },
        {
          label: "高中及以上",
          value: 3,
        },
        {
          label: "专科及以上",
          value: 4,
        },
        {
          label: "本科及以上",
          value: 5,
        },
        {
          label: "硕士及以上",
          value: 6,
        },
        {
          label: "博士",
          value: 7,
        },
      ],
      province_list: [],
      city_list: [],
      district_list: [],
      disLimit: {
        maxAgeLimit: "",
        maxAmountLimit: "",
      },
      // rules表单验证 unit
      rules: {
        taskType: [
          { required: true, message: "请选择任务类型", trigger: "blur" },
        ],
        taskName: [
          { required: true, message: "请输入任务名称", trigger: "blur" },
        ],
        settlementCycle: [
          { required: true, message: "请选择结算周期", trigger: "blur" },
        ],
        date: [{ required: true, message: "请选择用工周期", trigger: "blur" }],
        unit: [
          // { required: true, message: "请选择计费单位", trigger: "blur" },
          { validator: this.validateUnit, trigger: "blur" },
        ],
        gender: [
          { required: true, message: "请选择用工性别", trigger: "blur" },
        ],
        educationLevel: [
          { required: true, message: "请选择用工学历", trigger: "blur" },
        ],
        minCharge: [
          { required: true, message: "请输入最低计费", trigger: "blur" },
          { validator: this.validateMinCharge, trigger: "blur" },
        ],
        maxCharge: [
          // { required: true, message: "请输入最高计费", trigger: "blur" },
          { validator: this.validateMaxCharge, trigger: "blur" },
        ],
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        minAge: [
          { required: true, message: "请输入最小年龄", trigger: "blur" },
          { validator: this.validateMinAge, trigger: "blur" },
        ],
        maxAge: [
          // { required: true, message: "请输入最大年龄", trigger: "blur" },
          { validator: this.validateMaxAge, trigger: "blur" },
        ],
        locationVoList: [
          { required: true, message: "请输入服务地点", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入服务内容", trigger: "blur" },
        ],
        billMode: [
          { required: true, message: "请输入计费模式", trigger: "blur" },
        ],
        serviceTime: [
          { required: true, message: "请输入服务时间", trigger: "blur" },
        ],
      },
      formInline: {
        page: 1,
        pageSize: 10,
        taskId: "",
        taskName: "",
        status: "",
        startDate: "",
        endDate: "",
        invoiceCategory: "",
        date: [],
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
    this.province_list = [{ name: "不限", code: "", city: [] }];
    this.province_list = this.province_list.concat(china);
    // this.province_list = china;
    gettasksTypes().then((res) => {
      this.tasktype_list = res.data;
    });
    getDisLimit().then((res) => {
      if (res.msg == "success") {
        this.disLimit.maxAgeLimit = res.data.maxAgeLimit;
        this.disLimit.maxAmountLimit = res.data.maxAmountLimit;
      } else {
        this.$message({
          type: "error",
          message: res.msg,
        });
      }
    });
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        taskId: "",
        taskName: "",
        status: "",
        startDate: "",
        endDate: "",
        date: [],
      };
      this.getdata(this.formInline);
    },
    //导出数据
    exportData() {
      let params = {
        page: 1,
        pageSize: 999999999,
        taskId: this.formInline.taskId,
        taskName: this.formInline.taskName,
        status: this.formInline.status,
        startDate: this.formInline.date[0] || "",
        endDate: this.formInline.date[1] || "",
        invoiceCategory: "",
      };

      exportTask(params)
        .then((res) => {
          window.open(res.data.downloadUrl);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getOtherAccountTasks() {
      this.taskMigrationLoading = true;
      getAllAccountTasks()
        .then((res) => {
          this.taskMigrationLoading = false;
          if (res.msg == "success") {
            this.taskMigrationList = res.data;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onTaskMigration() {
      this.taskMigrationList = [];
      this.getOtherAccountTasks();
      this.taskMigrationDialogVisible = true;
    },
    handleSelectionChange(val) {
      this.multipleSelectionTasks = val;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleTaskMigration() {
      if (
        !this.multipleSelectionTasks ||
        this.multipleSelectionTasks.length === 0
      ) {
        this.$message.error("请选择要导入的任务");
        return;
      }

      this.$confirm(
        "任务在导入不同服务商时，任务中最大年龄和最大下发金额会按该服务商默认配置。确定导入选中任务?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const taskIds = this.multipleSelectionTasks.map(
            (item) => item.taskId
          );
          tasksMigration(taskIds) // 传递选中的任务
            .then((res) => {
              if (res.msg === "success") {
                this.taskMigrationDialogVisible = false;
                this.getdata(this.formInline);
                this.$message.success("任务导入成功");
              } else {
                this.$message.error(res.msg || "导入失败，请重试");
              }
            })
            .catch((error) => {
              this.$message.error("网络错误，请稍后重试");
            });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    provinceChanged(val) {
      if (val.name === "不限") {
        this.editForm.locationVoList[0].province = "不限";
        this.editForm.locationVoList[0].city = "不限"; // 重置城市选择
        this.editForm.locationVoList[0].district = "不限"; // 重置区县选择
        this.city_list = [{ name: "不限", code: "", area: [] }];
      } else {
        this.editForm.locationVoList[0].city = "";
        this.editForm.locationVoList[0].district = "";
        this.city_list = val.city;
        this.editForm.locationVoList[0].province = val.name;
      }
    },
    cityChanged(val) {
      if (val.name === "不限") {
        this.editForm.locationVoList[0].district = "";
        this.district_list = [{ name: "不限", code: "" }];
        this.editForm.locationVoList[0].city = "不限";
      } else {
        this.editForm.locationVoList[0].district = "";
        this.district_list = val.area;
        this.editForm.locationVoList[0].city = val.name;
      }
    },
    add_task() {
      this.form_dialog.title = "新建任务";
      this.form_dialog.visible = true;
      this.editForm = {
        taskType: "",
        date: [],
        // taskId: '',
        taskName: "",
        settlementCycle: "",
        minCharge: "",
        maxCharge: "",
        unit: "",
        gender: "",
        educationLevel: "",
        minAge: "",
        maxAge: "",
        content: "",
        billMode: "",
        serviceTime: "",
        otherBenefits: "",
        locationVoList: [
          {
            province: "",
            city: "",
            district: "",
          },
        ],
      };
    },
    changeStatus(val, row) {
      let parameter = {
        status: val == true ? 1 : 0,
      };
      editDeptListStatus(row.taskId, parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg == "success") {
            this.getdata(this.formInline);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 获取公司列表
    getdata(parameter) {
      let params = {
        page: this.formInline.page,
        pageSize: this.formInline.pageSize,
        taskId: this.formInline.taskId,
        taskName: this.formInline.taskName,
        status: this.formInline.status,
        startDate: this.formInline.date[0] || "",
        endDate: this.formInline.date[1] || "",
        invoiceCategory: "",
      };
      this.loading = true;
      deptList(params)
        .then((res) => {
          this.loading = false;
          if (res.msg == "success") {
            this.listData = res.data.items;
            // this.listData.map(item => {
            //   if(item.recruitmentStateDesc == '上线'){
            //     item.status = true
            //   }else{
            //     item.status = false
            //   }
            // })
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    showShareDialog(row) {
      if (!row || !row.taskId) {
        console.error("任务信息不完整，无法获取二维码");
        this.$message.error("任务信息不完整，无法获取二维码");
        return;
      }
      this.shareDialogVisible = true;
      this.qrcodeLoading = true;
      getQrcodeUrl(row.taskId)
        .then((response) => {
          console.log(response);
          if (response.msg == "success") {
            this.qrcodeUrl = "data:image/png;base64," + response.data;
            this.qrTaskName = row.taskName;
          } else {
            this.$message.error("获取二维码失败，请稍后重试");
          }
        })
        .catch((error) => {
          console.error("获取二维码链接失败:", error);
          this.$message.error("获取二维码失败，请稍后重试");
          this.qrcodeUrl = "";
        })
        .finally(() => {
          this.qrcodeLoading = false;
          if (!this.qrcodeUrl) {
            this.shareDialogVisible = false;
          }
        });
    },

    downloadQRCode() {
      if (!this.qrcodeUrl) return;

      // 创建虚拟链接
      const link = document.createElement("a");
      link.href = this.qrcodeUrl;

      // 设置下载文件名（可根据需求动态生成）

      link.download = `【任务报名】扫码报名任务_${this.qrTaskName}.png`;

      // 触发下载
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 可选：添加下载成功提示
      this.$message.success("二维码已保存至本地");
    },
    viewRegistrationDtl(id) {
      this.$router.push({
        path: "/task/registrationDtl",
        query: {
          id: id,
        },
      });
    },
    //显示编辑界面
    handleEdit(row) {
      console.log(row);
      this.form_dialog.title = "编辑任务";
      this.editForm = row;
      this.editForm.date = [row.startTime, row.endTime];
      this.editForm.locationVoList = [
        {
          province: "",
          city: "",
          district: "",
        },
      ];
      this.editForm.locationVoList[0].province = row.location.split("-")[0];
      this.editForm.locationVoList[0].city = row.location.split("-")[1];
      this.editForm.locationVoList[0].district = row.location.split("-")[2];

      this.editForm = JSON.parse(JSON.stringify(this.editForm));
      this.form_dialog.visible = true;
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          let params = {
            taskType: this.editForm.taskType, // 任务类型
            taskName: this.editForm.taskName, // 任务名称
            settlementCycle: this.editForm.settlementCycle, // 结算周期
            startTime: this.editForm.date[0], // 用工周期-开始日期
            endTime: this.editForm.date[1], // 用工周期-结束日期
            minCharge: this.editForm.minCharge, // 任务计费-最低计费
            maxCharge: this.editForm.maxCharge, // 任务计费-最高计费
            unit: this.editForm.unit, // 单位
            gender: this.editForm.gender, // 性别要求
            educationLevel: this.editForm.educationLevel, // 学历要求
            minAge: this.editForm.minAge, // 年龄要求-最小年龄
            maxAge: this.editForm.maxAge, // 年龄要求-最高要求
            locationVoList: this.editForm.locationVoList, // 服务地点
            content: this.editForm.content, // 服务内容
            billMode: this.editForm.billMode, // 计费模式
            serviceTime: this.editForm.serviceTime, // 服务时间
            otherBenefits: this.editForm.otherBenefits, // 其它福利
          };
          if (this.form_dialog.title == "编辑任务") {
            editDeptList(this.editForm.taskId, params)
              .then((res) => {
                this.loading = false;
                console.log(res);
                if (res.msg == "success") {
                  this.form_dialog.visible = false;
                  this.getdata(this.formInline);
                  this.$message({
                    type: "success",
                    message: "编辑成功！",
                  });
                } else {
                  this.form_dialog.visible = true;
                  this.$message({
                    type: "error",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.form_dialog.visible = false;
                this.loading = false;
                this.$message.error("操作失败，请稍后再试！");
              });
          } else {
            createDeptList(params)
              .then((res) => {
                this.loading = false;
                console.log(res);
                if (res.msg == "success") {
                  this.form_dialog.visible = false;
                  this.getdata(this.formInline);
                  this.$message({
                    type: "success",
                    message: "创建成功！",
                  });
                } else {
                  this.form_dialog.visible = true;
                  this.$message({
                    type: "error",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.form_dialog.visible = false;
                this.loading = false;
                this.$message.error("操作失败，请稍后再试！");
              });
          }
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let parameter = {
            status: 2,
          };
          editDeptListStatus(row.taskId, parameter)
            .then((res) => {
              this.loading = false;
              if (res.msg == "success") {
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败！");
            });
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "已取消删除",
          });
        });
    },
    getDisLimit() {},
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.form_dialog.visible = false;
    },
    validateUnit(rule, value, callback) {
      if (value === "") {
        return callback(new Error("请选择计费单位"));
      }

      callback();
    },

    validateMinCharge(rule, value, callback) {
      if (value === "") {
        return callback(new Error("请输入最低计费"));
      }

      // 默认最大98000
      if (
        this.disLimit.maxAmountLimit === "" ||
        this.disLimit.maxAmountLimit === 0 ||
        this.disLimit.maxAmountLimit === null
      ) {
        this.disLimit.maxAmountLimit = 98000;
      }

      const charge = parseInt(value, 10);
      if (isNaN(charge)) {
        callback(new Error("请输入有效的数字"));
      } else if (charge < 1 || charge > this.disLimit.maxAmountLimit) {
        callback(
          new Error(`最低计费必须大于1小于${this.disLimit.maxAmountLimit}元`)
        );
      } else {
        callback();
      }
    },
    validateMaxCharge(rule, value, callback) {
      if (value === "") {
        return callback(new Error("请输入最高计费"));
      }

      // 默认最大98000
      if (
        this.disLimit.maxAmountLimit === "" ||
        this.disLimit.maxAmountLimit === 0 ||
        this.disLimit.maxAmountLimit === null
      ) {
        this.disLimit.maxAmountLimit = 98000;
      }

      const minCharge = parseFloat(this.editForm.minCharge);
      const charge = parseInt(value, 10);

      if (!minCharge) {
        return callback(new Error("请先输入最低计费"));
      }
      if (charge <= minCharge) {
        return callback(new Error("最高计费必须大于最低计费"));
      }
      if (isNaN(charge)) {
        callback(new Error("请输入有效的数字"));
      } else if (charge > this.disLimit.maxAmountLimit || charge < 1) {
        callback(
          new Error(`最高计费必须小于${this.disLimit.maxAmountLimit}大于1元`)
        );
      } else {
        callback();
      }
    },
    validateMinAge(rule, value, callback) {
      if (value === "") {
        return callback(new Error("请输入最小年龄"));
      }
      // 默认最大65
      if (
        this.disLimit.maxAgeLimit === "" ||
        this.disLimit.maxAgeLimit === 0 ||
        this.disLimit.maxAgeLimit === null
      ) {
        this.disLimit.maxAgeLimit = 65;
      }
      const age = parseInt(value, 10);
      if (isNaN(age)) {
        callback(new Error("请输入有效的数字"));
      } else if (age < 18 || age > this.disLimit.maxAgeLimit) {
        callback(
          new Error(
            `最小年龄必须大于等于18岁小于等于${this.disLimit.maxAgeLimit}岁`
          )
        );
      } else {
        callback();
      }
    },
    validateMaxAge(rule, value, callback) {
      if (value === "") {
        return callback(new Error("请输入最大年龄"));
      }

      // 默认最大65
      if (
        this.disLimit.maxAgeLimit === "" ||
        this.disLimit.maxAgeLimit === 0 ||
        this.disLimit.maxAgeLimit === null
      ) {
        this.disLimit.maxAgeLimit = 65;
      }

      const minAge = parseInt(this.editForm.minAge);
      const age = parseInt(value, 10);

      if (!minAge) {
        return callback(new Error("请先输入最低年龄"));
      }

      if (age <= minAge) {
        return callback(new Error("最大年龄必须大于最低年龄"));
      }

      if (isNaN(age)) {
        callback(new Error("请输入有效的数字"));
      } else if (age > this.disLimit.maxAgeLimit || age < 18) {
        callback(
          new Error(
            `最小年龄必须大于等于18岁小于等于${this.disLimit.maxAgeLimit}岁`
          )
        );
      } else {
        callback();
      }
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.info-block {
  background: #fff;
  border: 1px solid #e5e5e5;
  margin-bottom: 20px;
}
.info-block .info-title {
  background-color: #f0f2f5;
  margin: 0 !important;
  font-size: 16px;
  padding: 0 32px;
  line-height: 56px;
  border-bottom: 1px solid #e5e5e5;
}
.info-block .info-body {
  padding: 24px 32px;
}
.blockTitle span:nth-child(2) {
  font-size: 18px;
  color: #272727;
  margin-top: 10px;
  font-weight: 700;
}
.blockTitleOrage span:nth-child(2) {
  color: #ff943e;
  font-weight: 700;
  font-size: 20px;
  margin-top: 10px;
}

.qrcode-container {
  text-align: center;
  padding: 15px 0;
}

/* 二维码图片样式 */
.qrcode-container img {
  width: 250px;
  height: 250px;
  display: block;
  margin: 0 auto;
}

/* 任务名称样式 */
.task-name {
  font-size: 16px;
  color: #333;
  font-weight: 400;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
  word-break: break-word;
}

.ellipsis-text {
  white-space: nowrap; /* 强制不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  width: 100%; /* 继承父容器宽度，确保以列宽为基准截断 */
}
</style>

 


// WEBPACK FOOTER //
// src/views/task/taskList.vue